import Http from '../Http';
import {
  addVersion,
} from '../HelperAPI';

const baseUrl = `${process.env.VAPI_BASE_URL}/flights`;

export default {
  list: (data, options) => {
    options = addVersion('8.19.0', options);
    return Http.post(`${baseUrl}/search`, data, options);
  },
  getById: (id, options) => {
    options = addVersion('8.19.0', options);
    return Http.get(`${baseUrl}/${id}`, options);
  },
  summary: (id, options) => {
    options = addVersion('8.19.0', options);
    return Http.get(`${baseUrl}/${id}/summary`, options);
  },
  history: (data, options) => Http.post(`${baseUrl}/${data._id}/history`, data, options),
  copy: (id, options) => Http.post(`${baseUrl}/${id}/copy`, {}, options),
  confirm: (id, options) => Http.post(`${baseUrl}/${id}/confirmation`, {}, options),
  unconfirm: (id, options) => Http.delete(`${baseUrl}/${id}/confirmation`, options),
  create: (data, options) => {
    options = addVersion('8.8.0', options);
    return Http.post(baseUrl, data, options);
  },
  update: (data, options) => {
    options = addVersion('8.8.0', options);
    return Http.put(`${baseUrl}/${data._id}`, data, options);
  },
  addNote: (data, options) => {
    return Http.post(`${baseUrl}/${data._id}/notes`, data, options);
  },
  reactivate: (data, options) => {
    options = addVersion('5.36.0', options);
    return Http.post(`${baseUrl}/${data._id}`, data, options);
  },
  deactivate: (id) => Http.delete(`${baseUrl}/${id}`),

  // Delivery System
  DeliverySystem: {
    list: (data, options) => Http.post(`${baseUrl}/deliverysystems/search`, data, options),
    create: (data) => Http.post(`${baseUrl}/deliverysystems`, data),
    update: (data) => Http.put(`${baseUrl}/deliverysystems/${data._id}`, data),
    reactivate: (data, options) => Http.post(`${baseUrl}/deliverysystems/${data._id}`, data, options),
    deactivate: (id) => Http.delete(`${baseUrl}/deliverysystems/${id}`),
  },

  // Segments
  Segment: {
    list: (data, options) => Http.post(`${baseUrl}/${data.flightId}/segments/search`, data, options),
    get: async (data, options) => {
      options = addVersion('8.34.0', options);
      const response = await Http.get(`${baseUrl}/${data.flightId}/segments/${data.segmentId}`, options);
      response.dayParts = response.dayParts?.map(dayPart => {
        return {
          ...dayPart,
          dateRanges: dayPart.dateRanges.map((dateRange) => {
            const creatives = dateRange?.creatives ?? [];
            return {
              ...dateRange,
              creatives: creatives?.map(creative => {
                creative.media?.map(mediaItem => {
                  mediaItem.url = Http.cloudfront(mediaItem.url);
                  return mediaItem;
                });
                return creative;
              }),
            };
          }),
        };
      }) ?? response.dayParts;
      return response;
    },
    getExpandedLocations: async (data, options) => {
      const response = await Http.get(
        `${baseUrl}/${data.flightId}/segments/${data.segmentId}/locations/expanded`,
        options,
      ) ?? [];

      return response.map(item => {
        const locations = item.locations ?? [];

        return {
          ...item,
          imageUrl: Http.cloudfront(item.imageUrl),
          locations: locations.map(location => {
            return {
              ...location,
              imageUrl: Http.cloudfront(location.imageUrl),
            };
          }),
        };
      });
    },
    history: (data, options) => {
      return Http.post(`${baseUrl}/${data.flightId}/segments/${data.segment._id}/history`, data, options);
    },
    create: (data, options) => {
      options = addVersion('8.8.0', options);
      return Http.post(`${baseUrl}/${data.flightId}/segments`, data, options);
    },
    createScenario: (data, options) => {
      options = addVersion('8.8.0', options);
      return Http.post(`${baseUrl}cenarios`, data, options);
    },
    update: (data, options) => {
      options = addVersion('8.8.0', options);
      return Http.put(`${baseUrl}/${data.flightId}/segments/${data._id}`, data, options);
    },
    reactivate: (data, options) => {
      options = addVersion('5.36.0', options);
      return Http.post(`${baseUrl}/${data.flightId}/segments/${data._id}`, data, options);
    },
    deactivate: (data) => Http.delete(`${baseUrl}/${data.flightId}/segments/${data._id}`),

    // Segment Summaries
    Summary: {
      companies: (data, options) => {
        return Http.post(`${baseUrl}/${data.flightId}/segments/${data.segmentId}/summary/companies`, data, options);
      },
      banners: (data, options) => {
        return Http.post(`${baseUrl}/${data.flightId}/segments/${data.segmentId}/summary/banners`, data, options);
      },
      locations: (data, options) => {
        return Http.post(`${baseUrl}/${data.flightId}/segments/${data.segmentId}/summary/locations`, data, options);
      },
    },
  },

  // Flight Summaries
  Summary: {
    companies: (data, options) => {
      return Http.post(`${baseUrl}/${data.flightId}/summary/companies`, data, options);
    },
    banners: (data, options) => {
      return Http.post(`${baseUrl}/${data.flightId}/summary/banners`, data, options);
    },
    locations: (data, options) => {
      return Http.post(`${baseUrl}/${data.flightId}/summary/locations`, data, options);
    },
  },

  Approval: {
      getPartnerApprovers: async (data, options) => {
        const response = await Http.post(`${baseUrl}/approvers/partner`, data, options);
  
        return response.map(item => {
          return {
            ...item,
            imageUrl: Http.cloudfront(item.imageUrl),
          };
        });
      },
      requestChanges: (data, options) => {
        return Http.post(`${baseUrl}/${data._id}/review`, data, options);
      },
      approve: (data, options) => {
        return Http.post(`${baseUrl}/${data._id}/review`, data, options);
      },
      recall: (data, options) => {
        return Http.post(`${baseUrl}/${data._id}/recall`, data, options);
      },
    },
};
